import { createContext, useContext } from "react";
import horizontalLight from "../../assets/brand/logo-horizontal-light.svg";
import horizontalDark from "../../assets/brand/logo-horizontal-dark.svg";
import symbolColor from "../../assets/brand/symbol-color.svg";
import { PLATFORM_NAME } from "../../lib/marke";
import "./logo.css";

/**
 * Logo von CreatorOffice (Marke seit 29.09.2026; Dateien unverändert aus brand/creatoroffice/svg). Hell-Ansicht: light-Variante,
 * Dunkel-Ansicht (html[data-theme="dark"]): dark-Variante; die Umschaltung macht logo.css, damit kein Flackern entsteht und
 * der Wechsel der Darstellung ohne neues Zeichnen greift.
 *
 * Verbindliche Regel: Rahmen (Kopfzeile, Seitenleiste, Handy-Leiste, Anmelde- und öffentliche Seiten) tragen immer dieses Logo.
 * Ein Logo der Agentur ersetzt es dort nie; das Agenturlogo gehört nur auf Dokumente und Außendarstellung der Agentur
 * (Rechnungen, Gutschriften, Mahnungen, Angebote, Verträge, Mails, Media-Kit, Freigabe- und Berichtsseiten).
 *
 * form: „full“ immer die horizontale Anordnung, „symbol“ nur das Zeichen (schmale Stellen), „responsive“ horizontal und
 * am Handy (bis 760 px) nur das Zeichen. size: „md“ Kopfzeilen (240 px breit, empfohlene Mindestbreite), „sm“ Seitenrahmen
 * öffentlicher Dokumentseiten (klein, das Dokument der Agentur steht im Vordergrund).
 */
export type LogoForm = "full" | "symbol" | "responsive";

export function CreatorOfficeLogo({ form = "responsive", size = "md", className }: { form?: LogoForm; size?: "sm" | "md"; className?: string }) {
  return (
    <span className={`co-logo${className ? ` ${className}` : ""}`} data-form={form} data-size={size} role="img" aria-label={PLATFORM_NAME}>
      {form !== "symbol" && <img className="co-full co-light" src={horizontalLight} alt="" draggable={false} />}
      {form !== "symbol" && <img className="co-full co-dark" src={horizontalDark} alt="" draggable={false} />}
      {form !== "full" && <img className="co-symbol" src={symbolColor} alt="" draggable={false} />}
    </span>
  );
}

/** true innerhalb eines Rahmens mit eigenem Kopf (Portal, Website-Rahmen, öffentliche Seiten, Betreiber-Konsole). */
export const RahmenKontext = createContext(false);

/**
 * Kopf für Seiten ohne Rahmen (404, Fehler- und Sperrseiten vor dem Portal, Start ohne Agentur): oben links das
 * CreatorOffice-Logo. Innerhalb eines Rahmens (RahmenKontext) erscheint nichts, der Rahmen trägt das Logo schon.
 */
export function EigenerKopf() {
  if (useContext(RahmenKontext)) return null;
  return (
    <header className="webnav tk-noprint co-eigener-kopf">
      <a className="brand co-brand" href="/"><CreatorOfficeLogo form="responsive" /></a>
    </header>
  );
}

/** Adressen der Logodateien (für Tests und Stellen außerhalb von React). */
export const LOGO_FILES = { horizontalLight, horizontalDark, symbolColor } as const;
